import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SET_SESSIONID,
  SIGNIN_FACEBOOK_USER,
  SIGNIN_FACEBOOK_USER_SUCCESS,
  SIGNIN_GITHUB_USER,
  SIGNIN_GITHUB_USER_SUCCESS,
  SIGNIN_GOOGLE_USER,
  SIGNIN_GOOGLE_USER_SUCCESS,
  SIGNIN_TWITTER_USER,
  SIGNIN_TWITTER_USER_SUCCESS,
  SIGNIN_USER,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER,
  SIGNOUT_USER_SUCCESS,
  SIGNUP_USER,
  SIGNUP_USER_SUCCESS,
  APPLICANT_SIGNIN_USER,
  APPLICANT_SIGNIN_USER_SUCCESS,
  ADMIN_SIGNIN_USER,
  ADMIN_SIGNIN_USER_SUCCESS,
  ALUMNI_SIGNIN_USER,
  ALUMNI_SIGNIN_USER_SUCCESS,
  STUDENT_SIGNIN_USER,
  STUDENT_SIGNIN_USER_SUCCESS,
  UPDATE_REGSTATUS,
  UPDATE_USER_MODE,
  SET_PAGES,
  UNSET_PAGES,
  SET_STUDENT_PAGES,
  UNSET_STUDENT_PAGES,
} from "constants/ActionTypes";

export const userSignUp = (user) => {
  return {
    type: SIGNUP_USER,
    payload: user,
  };
};
export const setPages = (pages) => {
  return {
    type: SET_PAGES,
    payload: pages,
  };
};
export const unsetPages = () => {
  return {
    type: UNSET_PAGES
  };
};
export const setStudentPages = (pages) => {
  return {
    type: SET_STUDENT_PAGES,
    payload: pages,
  };
};
export const unsetStudentPages = () => {
  return {
    type: UNSET_STUDENT_PAGES
  };
};
export const applicantSignIn = (user) => {
  return {
    type: APPLICANT_SIGNIN_USER,
    payload: user,
  };
};
export const regStatus = (status) => {
  return {
    type: UPDATE_REGSTATUS,
    payload: status,
  };
};
export const adminSignIn = (user) => {
  return {
    type: ADMIN_SIGNIN_USER,
    payload: user,
  };
};
export const alumniSignin = (user) => {
  return {
    type: ALUMNI_SIGNIN_USER,
    payload: user,
  };
};
export const updateUsermode = (mode) => {
  return {
    type: UPDATE_USER_MODE,
    payload: mode,
  };
};
export const studentSignIn = (user) => {
  return {
    type: STUDENT_SIGNIN_USER,
    payload: user,
  };
};
export const userSignIn = (user) => {
  return {
    type: SIGNIN_USER,
    payload: user,
  };
};
export const userSignOut = (sessionID, userMode) => {
  return {
    type: SIGNOUT_USER,
    payload: {sessionID, userMode},
  };
};
export const userSignUpSuccess = (authUser) => {
  return {
    type: SIGNUP_USER_SUCCESS,
    payload: authUser,
  };
};
export const applicantSignInSuccess = (authUser) => ({
  type: APPLICANT_SIGNIN_USER_SUCCESS,
  payload: authUser,
});
export const alumniSigninSuccess = (authUser) => ({
  type: ALUMNI_SIGNIN_USER_SUCCESS,
  payload: authUser,
});
export const updateRegStatus = (authUser) => ({
  type: APPLICANT_SIGNIN_USER_SUCCESS,
  payload: authUser,
});
export const adminSignInSuccess = (authUser) => ({
  type: ADMIN_SIGNIN_USER_SUCCESS,
  payload: authUser,
});
export const studentSignInSuccess = (authUser) => ({
  type: STUDENT_SIGNIN_USER_SUCCESS,
  payload: authUser,
});
export const userSignInSuccess = (authUser) => ({
  type: SIGNIN_USER_SUCCESS,
  payload: authUser,
});
export const userSignOutSuccess = (userMode) => ({
  type: SIGNOUT_USER_SUCCESS,
  payload: userMode,
});
export const setSessionId = (sessionId) => ({
  type: SET_SESSIONID,
  payload: sessionId,
});


export const showAuthMessage = (message) => ({
  type: SHOW_MESSAGE,
  payload: message,
});

export const userGoogleSignIn = () => {
  return {
    type: SIGNIN_GOOGLE_USER,
  };
};
export const userGoogleSignInSuccess = (authUser) =>({
    type: SIGNIN_GOOGLE_USER_SUCCESS,
    payload: authUser,
  }
);
export const userFacebookSignIn = () => {
  return {
    type: SIGNIN_FACEBOOK_USER,
  };
};
export const userFacebookSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_FACEBOOK_USER_SUCCESS,
    payload: authUser,
  };
};
export const setInitUrl = (url) => {
  return {
    type: INIT_URL,
    payload: url,
  };
};
export const userTwitterSignIn = () => {
  return {
    type: SIGNIN_TWITTER_USER,
  };
};
export const userTwitterSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_TWITTER_USER_SUCCESS,
    payload: authUser,
  };
};
export const userGithubSignIn = () => {
  return {
    type: SIGNIN_GITHUB_USER,
  };
};
export const userGithubSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_GITHUB_USER_SUCCESS,
    payload: authUser,
  };
};
export const showAuthLoader = () => {
  return {
    type: ON_SHOW_LOADER,
  };
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE,
  };
};
export const hideAuthLoader = () => {
  return {
    type: ON_HIDE_LOADER,
  };
};
